import stockScreener from "./stock-screener";

export default {
    stockScreener,
}